import {
  FETCH_CATEGORY_EXPENSE_BIGS_FAILURE, FETCH_CATEGORY_EXPENSE_BIGS_REQUEST, FETCH_CATEGORY_EXPENSE_BIGS_SUCCESS, FETCH_CATEGORY_EXPENSE_BIGS_SUCCESS_2,
  FETCH_CATEGORY_EXPENSE_BIGS_SUCCESS_D, FETCH_CATEGORY_EXPENSE_BIG_FAILURE, FETCH_CATEGORY_EXPENSE_BIG_REQUEST, FETCH_CATEGORY_EXPENSE_BIG_SUCCESS
} from
  "../actions/actions";

// categoryexpensebigReducer.js
const initialState = {
  categoryexpensebigs: [],
  categoryexpensebigs2: [],
  // categoryexpensebigtype: {},
  categoryexpensebigSelect: {},
  loadingCategoryExpenseBig: false,
  loadingCategoryExpenseBigSelect: false,
  loadingCategoryExpenseBigs: false,
  errorCategoryExpenseBigs: null,
  errorCategoryExpenseBig: null
  // ... autres états spécifiques à categoryexpensebigReducer
};

const categoryexpensebigReducer = (state = initialState, action) => {
  switch (action.type) {

    case FETCH_CATEGORY_EXPENSE_BIG_REQUEST:
      // Dispatch une action pour définir loading sur true dans le globalReducer
      return {
        ...state,
        loadingCategoryExpenseBig: true,
        errorCategoryExpenseBig: ""
        // Autres manipulations d'état pour la demande de récupération des categoryexpensebigs
      };

    case FETCH_CATEGORY_EXPENSE_BIG_SUCCESS:
      return {
        ...state,
        loadingCategoryExpenseBig: false,
        errorCategoryExpenseBig: "",
        categoryexpensebigtype: action.payload
      };

    case FETCH_CATEGORY_EXPENSE_BIG_FAILURE:
      return {
        ...state,
        loadingCategoryExpenseBig: false,
        errorCategoryExpenseBig: action.payload
      };

    case FETCH_CATEGORY_EXPENSE_BIGS_REQUEST:
      return {
        ...state,
        loadingCategoryExpenseBigs: true,
        errorCategoryExpenseBigs: ""
      };

    case FETCH_CATEGORY_EXPENSE_BIGS_SUCCESS:
      return {
        ...state,
        categoryexpensebigs: action.payload,
        loadingCategoryExpenseBigs: false,
        errorCategoryExpenseBigs: ""
        // Autres manipulations d'état pour le succès de la récupération des categoryexpensebigs
      };

    case FETCH_CATEGORY_EXPENSE_BIGS_SUCCESS_2:
      return {
        ...state,
        categoryexpensebigs2: action.payload,
        loadingCategoryExpenseBigs: false,
        errorCategoryExpenseBigs: ""
        // Autres manipulations d'état pour le succès de la récupération des categoryexpensebigs
      };

    case FETCH_CATEGORY_EXPENSE_BIGS_SUCCESS_D:
      return {
        ...state,
        categoryexpensebigsD: action.payload,
        loadingCategoryExpenseBigs: false,
        errorCategoryExpenseBigs: ""
        // Autres manipulations d'état pour le succès de la récupération des categoryexpensebigs
      };

    case FETCH_CATEGORY_EXPENSE_BIGS_FAILURE:
      // Dispatch une action pour définir loading sur false dans le globalReducer et enregistrer l'erreur
      return {
        ...state,
        loadingCategoryExpenseBigs: false,
        errorCategoryExpenseBigs: action.payload
        // Autres manipulations d'état pour l'échec de la récupération des categoryexpensebigs
      };
    // ... autres cas pour d'autres actions liées aux categoryexpensebigs

    default:
      return state;
  }
};

export default categoryexpensebigReducer;